import injectSheet from 'react-jss';

import Desktop from './component';
import styles from './styles';

export default injectSheet(styles)(Desktop);
